import React, { ReactNode } from 'react'
import { Button } from '@shared/components/button'
import { Section } from '@shared/components/section'
import cx from 'classnames'

import styles from './style.module.scss'

export interface ComfortFormatBlock {
	id: number
	Icon: any
	title: ReactNode
	text: ReactNode
	btnText?: string
	onClick?: () => void
}

interface Props {
	blocks: ComfortFormatBlock[]
}

const ComfortBlock = ({ title, Icon, text, btnText, onClick }: ComfortFormatBlock) => {
	return (
		<div className={styles.comfortBlock}>
			<Icon className={styles.icon} />
			<h3 className={styles.comfortBlockTitle}>{title}</h3>
			<div>{text}</div>
			{btnText && onClick && (
				<Button onClick={onClick} className={styles.btn}>
					{btnText}
				</Button>
			)}
		</div>
	)
}

export const View = ({ blocks }: Props) => {
	return (
		<Section fullWidth className={styles.wrapper}>
			<div className={styles.row}>
				<h2 className={styles.sectionTitle}>
					Кроме технологий — бесплатное улучшение имиджа вашей компании
				</h2>
			</div>
			<div className={cx(styles.row, styles.rowComfortBlock)}>
				{blocks.map((block) => (
					<ComfortBlock key={block.id} {...block} />
				))}
			</div>
		</Section>
	)
}
